export type MediaType = "movie" | "series" | "variety";

export interface MediaItem {
  id: string;
  title: string;
  subtitle: string;
  type: MediaType;
  cover: string;
  heroImage: string;
  year: number;
  region: string;
  genres: string[];
  duration: string;
  rating: number;
  director: string;
  cast: string[];
  summary: string;
  plot: string;
  tags: string[];
  views: number;
  updatedAt: string;
  featured: boolean;
}

export const MEDIA: MediaItem[] = [
  // ---------------- 电影 movie ----------------
  {
    id: "m01",
    title: "长安夜行",
    subtitle: "古装武侠 · 盛唐风云",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20wuxia%20swordsman%20silhouette%20under%20moonlight%2C%20cinematic%20film%20poster%2C%20deep%20blue%20night%20and%20warm%20orange%20lantern%20light%2C%20dramatic%20rim%20lighting%2C%20minimalist%2C%20no%20text%2C%20high%20detail%2C%20dark%20clean%20background&width=600&height=900&seq=17c-m01&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=sweeping%20ancient%20chinese%20city%20rooftops%20at%20night%20with%20glowing%20lanterns%2C%20deep%20blue%20sky%20and%20warm%20orange%20light%2C%20cinematic%20wide%20shot%2C%20moody%20atmosphere%2C%20no%20text&width=1920&height=1080&seq=17c-hero-m01&orientation=landscape",
    year: 2025,
    region: "中国",
    genres: ["动作", "古装", "悬疑"],
    duration: "132分钟",
    rating: 8.6,
    director: "陆川舟",
    cast: ["沈砚", "苏晚棠", "裴无咎", "赵九斤"],
    summary: "盛唐长安一夜之间连发奇案，被贬的金吾卫旧部被迫重回暗夜，追查一场足以颠覆朝廷的密谋。",
    plot: "上元灯节前夜，长安城接连出现离奇命案，所有线索都指向十年前被掩埋的一桩旧案。昔日金吾卫校尉沈砚因得罪权贵被贬，如今被紧急召回。他与女捕快苏晚棠联手，在灯火与刀光之间穿行，一步步揭开隐藏在盛世之下的暗流。当真相逼近宫墙，他们必须在个人恩怨与家国大义之间做出抉择。",
    tags: ["盛唐", "权谋", "双雄", "悬疑推理"],
    views: 128400,
    updatedAt: "2026-09-28",
    featured: true,
  },
  {
    id: "m02",
    title: "星际回声",
    subtitle: "太空科幻 · 人类史诗",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=futuristic%20astronaut%20floating%20near%20a%20glowing%20planet%2C%20cinematic%20sci%20fi%20film%20poster%2C%20deep%20blue%20space%20and%20orange%20nebula%20glow%2C%20dramatic%20rim%20light%2C%20minimalist%2C%20no%20text%2C%20dark%20background&width=600&height=900&seq=17c-m02&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=astronaut%20silhouette%20before%20a%20giant%20orange%20nebula%20in%20deep%20blue%20space%2C%20cinematic%20wide%20shot%2C%20epic%20scale%2C%20no%20text&width=1920&height=1080&seq=17c-hero-m02&orientation=landscape",
    year: 2025,
    region: "美国",
    genres: ["科幻", "冒险", "剧情"],
    duration: "148分钟",
    rating: 8.9,
    director: "A. 卡尔森",
    cast: ["M. 雷耶斯", "H. 米勒", "周知遥"],
    summary: "人类接收到来自宇宙深处的神秘回声，一支深空船队踏上寻找信号源的单程之旅。",
    plot: "半个世纪前，地球收到一段无法破译的重复信号。如今技术终于成熟，国际深空组织派出「回声号」前往信号源。船员们在漫长航行中逐渐发现，这段信号并非来自陌生文明，而是来自未来的自己。当时间与因果开始扭曲，他们必须决定：是带回答案，还是让一切从未发生。",
    tags: ["硬科幻", "时间悖论", "深空", "IMAX"],
    views: 203100,
    updatedAt: "2026-09-30",
    featured: true,
  },
  {
    id: "m03",
    title: "深海档案",
    subtitle: "悬疑推理 · 潜水迷案",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=deep%20ocean%20diver%20with%20flashlight%20in%20dark%20water%2C%20cinematic%20thriller%20poster%2C%20deep%20blue%20water%20and%20orange%20light%20beam%2C%20suspenseful%20mood%2C%20no%20text%2C%20minimalist&width=600&height=900&seq=17c-m03&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=dark%20deep%20ocean%20with%20a%20single%20orange%20light%20beam%20descending%2C%20cinematic%20mystery%20wide%20shot%2C%20deep%20blue%20water%2C%20no%20text&width=1920&height=1080&seq=17c-hero-m03&orientation=landscape",
    year: 2024,
    region: "中国",
    genres: ["悬疑", "惊悚", "剧情"],
    duration: "118分钟",
    rating: 8.2,
    director: "顾清和",
    cast: ["方舟", "林以宁", "宋辞"],
    summary: "一支打捞队深入沉船残骸，却在水下发现一份指向二十年前失踪案的加密档案。",
    plot: "经验丰富的潜水员方舟受雇打捞一艘沉没多年的货轮。在幽暗的水下，团队意外发现一只密封的金属箱，箱内的档案记录了一起从未被公开的连环失踪案。随着上浮减压的每一分钟，队伍内部开始互相猜忌。谁是这段真相的守护者，谁又是当年事件的参与者，答案藏在比深海更暗的人心里。",
    tags: ["水下", "推理", "密室", "反转"],
    views: 96400,
    updatedAt: "2026-09-21",
    featured: false,
  },
  {
    id: "m04",
    title: "山那边的夏天",
    subtitle: "文艺剧情 · 成长记忆",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=lone%20figure%20standing%20on%20a%20green%20mountain%20ridge%20at%20sunset%2C%20cinematic%20indie%20drama%20poster%2C%20warm%20orange%20sky%20and%20deep%20blue%20hills%2C%20nostalgic%20mood%2C%20no%20text%2C%20minimalist&width=600&height=900&seq=17c-m04&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=rolling%20green%20mountains%20under%20a%20warm%20orange%20sunset%20sky%2C%20cinematic%20peaceful%20wide%20shot%2C%20deep%20blue%20layered%20hills%2C%20no%20text&width=1920&height=1080&seq=17c-hero-m04&orientation=landscape",
    year: 2024,
    region: "中国",
    genres: ["剧情", "文艺", "家庭"],
    duration: "106分钟",
    rating: 8.4,
    director: "许知远",
    cast: ["周夏", "陈砚秋", "小满"],
    summary: "少年在祖母的老屋度过最后一个夏天，也第一次真正读懂了家人沉默背后的爱。",
    plot: "高考结束后的夏天，少年周夏被父母送回山那边的小镇，陪独居的祖母度过假期。他原本只想尽快逃离这个没有网络的地方，却在修理旧收音机、修补漏雨屋顶的日常里，慢慢拼凑出父母年轻时未曾讲述的故事。一个夏天结束，山还是那座山，人却已经不一样了。",
    tags: ["治愈", "青春", "乡土", "获奖"],
    views: 61200,
    updatedAt: "2026-08-30",
    featured: false,
  },
  {
    id: "m05",
    title: "幻影列车",
    subtitle: "惊悚悬疑 · 密闭空间",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=old%20night%20train%20speeding%20through%20darkness%2C%20cinematic%20horror%20thriller%20poster%2C%20deep%20blue%20night%20and%20warm%20orange%20window%20lights%2C%20ominous%20mood%2C%20no%20text%2C%20minimalist&width=600&height=900&seq=17c-m05&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=vintage%20express%20train%20rushing%20through%20a%20dark%20blue%20night%20with%20orange%20lights%2C%20cinematic%20suspense%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-m05&orientation=landscape",
    year: 2025,
    region: "英国",
    genres: ["惊悚", "悬疑", "剧情"],
    duration: "112分钟",
    rating: 7.9,
    director: "E. 哈洛威",
    cast: ["L. 格雷", "T. 韦斯特", "吴念"],
    summary: "一趟没有终点站的夜间列车，乘客们发现每停靠一次，就少一个人。",
    plot: "雨夜，一列本应只开往邻城的旧式列车载着互不相识的乘客驶入浓雾。车票上印着从未见过的站名，广播里反复播放同一段提示。随着车厢一节节变空，幸存者才意识到，他们每个人都在逃亡同一段不愿面对的记忆。要下车，就必须先说出真相。",
    tags: ["密闭", "反转", "群像", "氛围"],
    views: 73900,
    updatedAt: "2026-09-14",
    featured: false,
  },
  {
    id: "m06",
    title: "孤岛救援",
    subtitle: "灾难动作 · 极限求生",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=stormy%20ocean%20with%20lighthouse%20and%20tiny%20rescue%20boat%2C%20cinematic%20disaster%20action%20poster%2C%20deep%20blue%20storm%20and%20orange%20beacon%20light%2C%20dramatic%2C%20no%20text%2C%20minimalist&width=600&height=900&seq=17c-m06&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=violent%20storm%20waves%20around%20a%20lighthouse%20and%20rescue%20boat%2C%20cinematic%20disaster%20wide%20shot%2C%20deep%20blue%20and%20orange%20beacon%20glow%2C%20no%20text&width=1920&height=1080&seq=17c-hero-m06&orientation=landscape",
    year: 2025,
    region: "韩国",
    genres: ["动作", "灾难", "剧情"],
    duration: "126分钟",
    rating: 8.1,
    director: "金泰勋",
    cast: ["朴志勋", "韩秀雅", "李在赫"],
    summary: "超级台风来袭，一群普通救援队员必须在孤岛上完成不可能的营救。",
    plot: "超强台风正面登陆，一座偏远海岛与外界彻底失联。退役海警朴志勋与几名年轻队员驾驶仅剩的救援船逆浪出航。他们面对的不只是狂风巨浪，还有岛上等待救援的陌生人，以及多年未解的心结。当最后的救生艇只能载下一半人，选择本身就是一场考验。",
    tags: ["灾难", "救援", "团队", "催泪"],
    views: 88700,
    updatedAt: "2026-09-18",
    featured: false,
  },
  {
    id: "m07",
    title: "笑闹一家亲",
    subtitle: "家庭喜剧 · 欢乐闹剧",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=playful%20colorful%20family%20comedy%20film%20poster%2C%20warm%20orange%20and%20deep%20blue%20blocks%2C%20graphic%20minimalist%20style%2C%20cheerful%20mood%2C%20no%20text&width=600&height=900&seq=17c-m07&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=bright%20cheerful%20living%20room%20scene%20with%20warm%20orange%20and%20blue%20tones%2C%20cinematic%20comedy%20wide%20shot%2C%20cozy%20playful%20mood%2C%20no%20text&width=1920&height=1080&seq=17c-hero-m07&orientation=landscape",
    year: 2024,
    region: "中国",
    genres: ["喜剧", "家庭", "剧情"],
    duration: "98分钟",
    rating: 7.6,
    director: "马小跳",
    cast: ["周一围", "刘蓓", "小胖"],
    summary: "三代同堂的一家人为了一场婚礼同住一个屋檐下，鸡飞狗跳的日常笑料不断。",
    plot: "为了给最小的妹妹筹办婚礼，分散在各地的三家人被迫挤进老宅。作息不同、习惯不同、观念不同，从早餐吃什么到婚礼怎么办，每一件小事都能吵出一场大戏。可当婚礼当天突生变故，这一家人却在混乱中找回了久违的默契与温情。",
    tags: ["合家欢", "治愈", "爆笑", "温情"],
    views: 54100,
    updatedAt: "2026-08-22",
    featured: false,
  },
  {
    id: "m08",
    title: "风起云涌",
    subtitle: "犯罪剧情 · 都市暗战",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=noir%20city%20skyline%20at%20night%20with%20lone%20figure%20in%20coat%2C%20cinematic%20crime%20drama%20poster%2C%20deep%20blue%20city%20and%20orange%20street%20light%2C%20moody%2C%20no%20text&width=600&height=900&seq=17c-m08&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=rainy%20night%20city%20skyline%20with%20orange%20lights%20and%20deep%20blue%20sky%2C%20cinematic%20crime%20wide%20shot%2C%20noir%20mood%2C%20no%20text&width=1920&height=1080&seq=17c-hero-m08&orientation=landscape",
    year: 2025,
    region: "中国",
    genres: ["犯罪", "剧情", "悬疑"],
    duration: "124分钟",
    rating: 8.3,
    director: "郑亦风",
    cast: ["秦骁", "叶青", "老周"],
    summary: "一名固执的老刑警与年轻检察官联手，掀开一张盘踞城市多年的利益之网。",
    plot: "一起看似普通的交通肇事案，牵出一连串被刻意淡化的旧案。即将退休的老刑警秦骁不愿让真相随之退休，与初出茅庐的检察官叶青组成了最不被看好的搭档。他们面对的是一张遍布各处的利益网络，以及来自四面八方的压力。风起于青萍之末，而正义往往姗姗来迟。",
    tags: ["犯罪", "现实", "群像", "正剧"],
    views: 118600,
    updatedAt: "2026-09-25",
    featured: true,
  },

  // ---------------- 电视剧 series ----------------
  {
    id: "s01",
    title: "迷雾追凶",
    subtitle: "刑侦悬疑 · 连环谜案",
    type: "series",
    cover: "https://readdy.ai/api/search-image?query=detective%20silhouette%20on%20a%20foggy%20city%20street%20with%20police%20tape%2C%20cinematic%20crime%20series%20poster%2C%20deep%20blue%20fog%20and%20orange%20sodium%20light%2C%20moody%2C%20no%20text&width=600&height=900&seq=17c-s01&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=foggy%20city%20street%20at%20dawn%20with%20deep%20blue%20mist%20and%20orange%20street%20lamps%2C%20cinematic%20mystery%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-s01&orientation=landscape",
    year: 2026,
    region: "中国",
    genres: ["悬疑", "刑侦", "犯罪"],
    duration: "全35集",
    rating: 8.8,
    director: "何砚",
    cast: ["凌川", "白露", "程野"],
    summary: "尘封十五年的悬案重新浮出水面，年轻警探与退休法医联手在迷雾中寻找真相。",
    plot: "十五年前，一桩案件因证据不足草草结案。如今，相似的作案手法再次出现。年轻刑警凌川在档案室遇见坚持翻案的老法医，两人一个凭直觉、一个靠细节，在层层迷雾中拼凑真相。每一集都在揭开一个嫌疑人的秘密，而真正的答案，藏在最不起眼的一句话里。",
    tags: ["刑侦", "连环案", "慢热", "口碑"],
    views: 356000,
    updatedAt: "2026-10-08",
    featured: true,
  },
  {
    id: "s02",
    title: "大城小爱",
    subtitle: "都市情感 · 群像生活",
    type: "series",
    cover: "https://readdy.ai/api/search-image?query=young%20couple%20silhouette%20on%20a%20city%20balcony%20at%20dusk%2C%20cinematic%20romance%20series%20poster%2C%20deep%20blue%20dusk%20and%20warm%20orange%20window%20light%2C%20no%20text%2C%20minimalist&width=600&height=900&seq=17c-s02&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=city%20balconies%20and%20skyline%20at%20warm%20orange%20dusk%20with%20deep%20blue%20sky%2C%20cinematic%20romance%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-s02&orientation=landscape",
    year: 2026,
    region: "中国",
    genres: ["都市", "爱情", "生活"],
    duration: "全40集",
    rating: 8.0,
    director: "温以安",
    cast: ["许安然", "江屿", "苏棠"],
    summary: "一栋老小区里的三户邻居，在城市烟火气中书写关于爱情与生活的答卷。",
    plot: "同一栋老楼，三扇门，三种人生。程序员的深夜灯光、独居女孩的猫、退休教师的旧唱片，在日复一日的楼道相遇中渐渐交织。他们争吵、和解、互相借酱油，也在彼此最难的时候递上一碗热汤。这是一部关于城市里最普通、也最动人的爱的故事。",
    tags: ["都市", "群像", "烟火气", "治愈"],
    views: 289000,
    updatedAt: "2026-10-05",
    featured: false,
  },
  {
    id: "s03",
    title: "王朝的黎明",
    subtitle: "历史古装 · 权谋史诗",
    type: "series",
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20emperor%20in%20gold%20robe%20on%20throne%20steps%2C%20epic%20historical%20drama%20poster%2C%20deep%20blue%20shadows%20and%20warm%20orange%20torchlight%2C%20majestic%2C%20no%20text&width=600&height=900&seq=17c-s03&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20hall%20with%20torchlight%20and%20deep%20blue%20shadows%2C%20epic%20historical%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-s03&orientation=landscape",
    year: 2025,
    region: "中国",
    genres: ["历史", "古装", "权谋"],
    duration: "全60集",
    rating: 9.0,
    director: "张牧之",
    cast: ["萧景行", "聂云", "苏合", "陈望"],
    summary: "乱世末年，一位出身微末的少年如何一步步走向权力中心，开创属于他的时代。",
    plot: "王朝末年，天下板荡。出身寒门的萧景行本只想保全家人，却被时代推入棋局。他在权臣倾轧中学会隐忍，在战场生死间学会取舍，在一次次选择中逐渐成为那个最不像自己、也最像自己的人物。这是一部关于权力、理想与代价的宏大叙事，也是一代人的集体记忆。",
    tags: ["权谋", "群像", "正剧", "高口碑"],
    views: 412000,
    updatedAt: "2026-10-02",
    featured: true,
  },
  {
    id: "s04",
    title: "急诊室24小时",
    subtitle: "医疗职场 · 生死之间",
    type: "series",
    cover: "https://readdy.ai/api/search-image?query=emergency%20room%20doctor%20in%20teal%20scrubs%20under%20bright%20lights%2C%20cinematic%20medical%20drama%20poster%2C%20deep%20blue%20tones%20and%20warm%20orange%20accent%2C%20clean%2C%20no%20text&width=600&height=900&seq=17c-s04&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=modern%20hospital%20emergency%20corridor%20at%20night%20with%20deep%20blue%20light%20and%20warm%20orange%20glow%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-s04&orientation=landscape",
    year: 2026,
    region: "中国",
    genres: ["医疗", "职场", "剧情"],
    duration: "全32集",
    rating: 8.5,
    director: "林知白",
    cast: ["周医生", "宋护士长", "小吴"],
    summary: "一个急诊室，一群医护，每一个24小时都在与时间赛跑、与生命对话。",
    plot: "急诊室是医院里最没有剧本的地方。资深主治医师周岚习惯了在混乱中保持冷静，却在面对一个个普通家庭的故事时屡屡破防。新来的住院医从手忙脚乱到独当一面，护士长在制度与人情之间艰难平衡。这部剧不神话医生，只呈现那些真实发生在深夜的守护。",
    tags: ["医疗", "职业剧", "真实", "催泪"],
    views: 198000,
    updatedAt: "2026-10-06",
    featured: false,
  },
  {
    id: "s05",
    title: "山河故人记",
    subtitle: "年代剧情 · 家族变迁",
    type: "series",
    cover: "https://readdy.ai/api/search-image?query=family%20portrait%20in%20vintage%20chinese%20town%2C%20cinematic%20period%20drama%20poster%2C%20deep%20blue%20tones%20with%20warm%20orange%20sepia%20light%2C%20nostalgic%2C%20no%20text&width=600&height=900&seq=17c-s05&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=vintage%20chinese%20riverside%20town%20at%20warm%20orange%20dusk%20with%20deep%20blue%20mountains%2C%20cinematic%20period%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-s05&orientation=landscape",
    year: 2024,
    region: "中国",
    genres: ["年代", "剧情", "家庭"],
    duration: "全45集",
    rating: 8.9,
    director: "傅长河",
    cast: ["老李", "阿珍", "建军"],
    summary: "一条老街，一个家族，四十年风雨，讲述普通中国人如何在时代里扎根。",
    plot: "从上世纪八十年代讲起，一条临江老街上的李家三代人，经历了下海、进城、回归的漫长轨迹。父亲守着老铺子，儿子奔向远方，孙女又带着新的眼光回来。剧集用细密的生活细节，勾勒出个人命运与时代脉搏的同频共振，平凡而厚重。",
    tags: ["年代", "家族", "史诗", "高分"],
    views: 267000,
    updatedAt: "2026-09-20",
    featured: false,
  },
  {
    id: "s06",
    title: "次元边境",
    subtitle: "科幻奇幻 · 平行世界",
    type: "series",
    cover: "https://readdy.ai/api/search-image?query=glowing%20portal%20between%20two%20worlds%20with%20a%20lone%20traveler%2C%20cinematic%20fantasy%20sci%20fi%20series%20poster%2C%20deep%20blue%20and%20orange%20energy%2C%20no%20text%2C%20minimalist&width=600&height=900&seq=17c-s06&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=glowing%20blue%20and%20orange%20portal%20in%20a%20mysterious%20landscape%2C%20cinematic%20sci%20fi%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-s06&orientation=landscape",
    year: 2026,
    region: "日本",
    genres: ["科幻", "奇幻", "冒险"],
    duration: "全24集",
    rating: 8.4,
    director: "山口凉",
    cast: ["佐藤凛", "小野慧", "王星"],
    summary: "一道连接两个世界的裂缝出现，平凡的少年被卷入一场跨越次元的冒险。",
    plot: "高三学生佐藤凛在放学路上捡到一枚会发光的旧徽章，从此能够看见城市中隐藏的裂缝。裂缝的另一端，是一个规则截然不同、却共享着同样天空的世界。为了找回失踪的妹妹，他与来自另一端的少女组成搭档，在两个世界之间奔波，也逐渐发现裂缝背后更大的秘密。",
    tags: ["平行世界", "少年", "冒险", "高燃"],
    views: 176000,
    updatedAt: "2026-10-01",
    featured: false,
  },
  {
    id: "s07",
    title: "巷口食堂",
    subtitle: "生活治愈 · 深夜食光",
    type: "series",
    cover: "https://readdy.ai/api/search-image?query=cozy%20small%20restaurant%20at%20night%20with%20warm%20orange%20lantern%20and%20steam%2C%20cinematic%20healing%20series%20poster%2C%20deep%20blue%20night%2C%20no%20text%2C%20minimalist&width=600&height=900&seq=17c-s07&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=quiet%20old%20alley%20with%20a%20glowing%20small%20eatery%20at%20night%2C%20warm%20orange%20light%20and%20deep%20blue%20shadows%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-s07&orientation=landscape",
    year: 2025,
    region: "中国",
    genres: ["生活", "治愈", "美食"],
    duration: "全20集",
    rating: 8.6,
    director: "旧巷",
    cast: ["老板老陈", "小店员", "常客们"],
    summary: "巷口那家只在夜晚营业的小食堂，用一道道家常菜，温暖着每一个晚归的人。",
    plot: "老陈的食堂没有固定菜单，客人想吃什么，他就做什么。加班到深夜的白领、刚失恋的年轻人、退休后独居的老人，都在这张小小的桌子前坐下。每一集围绕一道菜、一个人、一段故事展开，食物的香气里，藏着城市最柔软的角落。",
    tags: ["治愈", "美食", "单元剧", "温暖"],
    views: 221000,
    updatedAt: "2026-09-27",
    featured: false,
  },
  {
    id: "s08",
    title: "暗流博弈",
    subtitle: "谍战悬疑 · 双面人生",
    type: "series",
    cover: "https://readdy.ai/api/search-image?query=spy%20in%20vintage%20coat%20standing%20in%20rain%20under%20a%20streetlight%2C%20cinematic%20espionage%20series%20poster%2C%20deep%20blue%20rain%20and%20orange%20lamp%2C%20tense%2C%20no%20text&width=600&height=900&seq=17c-s08&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=rainy%20night%20old%20city%20street%20with%20a%20single%20figure%20and%20orange%20lamp%2C%20cinematic%20espionage%20wide%20shot%2C%20deep%20blue%20mood%2C%20no%20text&width=1920&height=1080&seq=17c-hero-s08&orientation=landscape",
    year: 2025,
    region: "中国",
    genres: ["谍战", "悬疑", "剧情"],
    duration: "全38集",
    rating: 8.7,
    director: "沈墨",
    cast: ["程默", "顾晚", "老K"],
    summary: "潜伏在最深处的他，用一生守护一个不能说的名字。",
    plot: "动荡年代，程默带着双重身份蛰伏于敌营之中。他要在每一次接头、每一次试探里保持完美，也要在漫长的孤独中守住内心的信念。身边的同志一个个倒下，而距离胜利只剩最后一步。这不是一部追求爽感的谍战剧，而是一曲关于隐忍与信仰的挽歌。",
    tags: ["谍战", "信仰", "烧脑", "正剧"],
    views: 305000,
    updatedAt: "2026-09-23",
    featured: true,
  },

  // ---------------- 综艺 variety ----------------
  {
    id: "v01",
    title: "周末喜剧人",
    subtitle: "喜剧竞技 · 爆笑不断",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20comedy%20stage%20with%20colorful%20spotlights%2C%20variety%20show%20poster%2C%20warm%20orange%20and%20deep%20blue%20lights%2C%20playful%20graphic%20style%2C%20no%20text&width=600&height=900&seq=17c-v01&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=colorful%20comedy%20show%20stage%20with%20spotlights%20and%20a%20large%20audience%2C%20warm%20orange%20and%20deep%20blue%20lighting%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-v01&orientation=landscape",
    year: 2026,
    region: "中国",
    genres: ["喜剧", "竞技", "真人秀"],
    duration: "每周五更新",
    rating: 8.3,
    director: "综艺制作中心",
    cast: ["常驻喜剧人阵容", "飞行嘉宾"],
    summary: "一群喜剧新人同台竞技，用三分钟把观众逗笑，赢家拥有爆笑之王称号。",
    plot: "节目邀请来自各地的喜剧新人，围绕随机抽取的生活话题即兴创作。没有剧本、没有彩排，只有勇气和笑点。每期由现场观众投票，最冷场的人要接受惩罚，最爆笑的人则收获掌声。这是一档让人笑到停不下来的舞台竞技综艺。",
    tags: ["喜剧", "竞技", "即兴", "下饭"],
    views: 334000,
    updatedAt: "2026-10-09",
    featured: true,
  },
  {
    id: "v02",
    title: "一起去旅行吧",
    subtitle: "旅行真人秀 · 治愈出发",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=travel%20variety%20show%20poster%20with%20scenic%20road%20and%20suitcases%2C%20warm%20orange%20sunset%20and%20deep%20blue%20sky%2C%20playful%20graphic%20style%2C%20no%20text&width=600&height=900&seq=17c-v02&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=winding%20coastal%20road%20at%20warm%20orange%20sunset%20with%20deep%20blue%20sea%2C%20cinematic%20travel%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-v02&orientation=landscape",
    year: 2026,
    region: "中国",
    genres: ["旅行", "真人秀", "生活"],
    duration: "每周六更新",
    rating: 8.1,
    director: "综艺制作中心",
    cast: ["旅行团成员", "神秘向导"],
    summary: "六位性格迥异的嘉宾共用一份预算，在一座陌生城市完成一场没有攻略的旅行。",
    plot: "离开熟悉的城市，嘉宾们只拿到一张手绘地图和有限预算，必须自己问路、找住处、解决三餐。有人在语言不通时闹出笑话，有人在深夜小摊前说出心里话。旅行不只是看风景，更是重新认识同行的人和自己。",
    tags: ["旅行", "治愈", "群像", "慢综艺"],
    views: 256000,
    updatedAt: "2026-10-04",
    featured: false,
  },
  {
    id: "v03",
    title: "声动未来",
    subtitle: "音乐竞演 · 实力对决",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=concert%20stage%20with%20singer%20silhouette%20and%20glowing%20lights%2C%20music%20competition%20show%20poster%2C%20deep%20blue%20and%20orange%20spotlights%2C%20no%20text%2C%20minimalist&width=600&height=900&seq=17c-v03&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=large%20concert%20stage%20with%20deep%20blue%20and%20orange%20stage%20lights%20and%20crowd%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-v03&orientation=landscape",
    year: 2025,
    region: "中国",
    genres: ["音乐", "竞演", "真人秀"],
    duration: "每周日更新",
    rating: 8.5,
    director: "综艺制作中心",
    cast: ["实力唱将", "新声代歌手"],
    summary: "实力歌手与新声代同台竞演，用作品说话，用舞台征服观众。",
    plot: "节目打破资历界限，让不同代际的歌手同台。每期围绕一个主题重新编曲、改编经典或首唱原创。严苛的现场投票机制让每一次登台都充满压力，也让真正的好声音被更多人听见。音乐，是他们唯一需要证明的东西。",
    tags: ["音乐", "竞演", "舞台", "高燃"],
    views: 298000,
    updatedAt: "2026-10-03",
    featured: false,
  },
  {
    id: "v04",
    title: "美食奇遇记",
    subtitle: "美食探索 · 烟火人间",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=steaming%20street%20food%20dishes%20on%20a%20wooden%20table%2C%20food%20variety%20show%20poster%2C%20warm%20orange%20light%20and%20deep%20blue%20shadow%2C%20appetizing%2C%20no%20text&width=600&height=900&seq=17c-v04&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=night%20street%20food%20market%20with%20warm%20orange%20lights%20and%20steam%2C%20cinematic%20food%20wide%20shot%2C%20deep%20blue%20night%2C%20no%20text&width=1920&height=1080&seq=17c-hero-v04&orientation=landscape",
    year: 2025,
    region: "中国",
    genres: ["美食", "旅行", "生活"],
    duration: "每周三更新",
    rating: 8.2,
    director: "综艺制作中心",
    cast: ["美食探员", "本地向导"],
    summary: "跟着美食探员走街串巷，寻找藏在巷子深处、只有本地人才知道的味道。",
    plot: "节目走进不同城市，从清晨的早点摊到深夜的大排档，寻找那些没有招牌却排满长队的小馆。每一道菜的背后，都有一位坚持多年的手艺人。节目不追求猎奇，只想记录最真实的人间烟火与一饭一蔬里的深情。",
    tags: ["美食", "纪实", "下饭", "治愈"],
    views: 187000,
    updatedAt: "2026-09-29",
    featured: false,
  },
  {
    id: "v05",
    title: "智力大冲关",
    subtitle: "益智竞技 · 脑力对决",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=colorful%20puzzle%20and%20brain%20game%20graphic%20poster%2C%20deep%20blue%20and%20orange%20geometric%20blocks%2C%20smart%20modern%20style%2C%20no%20text&width=600&height=900&seq=17c-v05&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=futuristic%20game%20show%20arena%20with%20deep%20blue%20and%20orange%20lighting%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-v05&orientation=landscape",
    year: 2026,
    region: "中国",
    genres: ["益智", "竞技", "真人秀"],
    duration: "每周二更新",
    rating: 7.9,
    director: "综艺制作中心",
    cast: ["选手联盟", "出题官"],
    summary: "来自各行各业的选手同场比拼脑力，用逻辑与知识闯过一道道关卡。",
    plot: "节目设置记忆、推理、速算、观察等多个维度的关卡，考验的不只是智商，还有抗压与协作。选手们有学生、医生、程序员，也有退休教师。当难题被一步步解开，观众也能跟着一起动脑，体会思考的乐趣。",
    tags: ["益智", "竞技", "烧脑", "合家欢"],
    views: 143000,
    updatedAt: "2026-09-26",
    featured: false,
  },
  {
    id: "v06",
    title: "舞台新星",
    subtitle: "选秀养成 · 逐梦之路",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=young%20performers%20on%20a%20spotlight%20stage%20with%20hopeful%20mood%2C%20talent%20show%20poster%2C%20deep%20blue%20and%20warm%20orange%20lights%2C%20no%20text&width=600&height=900&seq=17c-v06&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=grand%20audition%20stage%20with%20deep%20blue%20and%20orange%20spotlights%20and%20young%20performers%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-v06&orientation=landscape",
    year: 2026,
    region: "中国",
    genres: ["选秀", "音乐", "养成"],
    duration: "每周四更新",
    rating: 8.0,
    director: "综艺制作中心",
    cast: ["导师团", "练习生"],
    summary: "一群怀揣舞台梦想的年轻人，在严苛的训练与竞演中成长为真正的新星。",
    plot: "节目记录练习生从入门到登台的完整过程。声乐、舞蹈、镜头感，每一课都残酷而真实。有天赋异禀却难以合群的人，有资质平平却从不放弃的人。导师的每一次点评都关乎去留，而观众见证的，是梦想如何被汗水一点点擦亮。",
    tags: ["选秀", "青春", "励志", "养成"],
    views: 209000,
    updatedAt: "2026-10-07",
    featured: false,
  },
  {
    id: "v07",
    title: "向往的小院",
    subtitle: "生活慢综艺 · 田园时光",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=cozy%20countryside%20courtyard%20with%20greenery%20and%20warm%20lanterns%20at%20dusk%2C%20slow%20life%20variety%20poster%2C%20orange%20warmth%20and%20deep%20blue%20dusk%2C%20no%20text&width=600&height=900&seq=17c-v07&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=peaceful%20countryside%20courtyard%20with%20warm%20orange%20evening%20light%20and%20deep%20blue%20sky%2C%20cinematic%20slow%20living%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-v07&orientation=landscape",
    year: 2025,
    region: "中国",
    genres: ["生活", "真人秀", "慢综艺"],
    duration: "每周一更新",
    rating: 8.4,
    director: "综艺制作中心",
    cast: ["常驻嘉宾", "每期客人"],
    summary: "几位嘉宾在一座乡间小院里种菜、做饭、待客，过一段慢下来的日子。",
    plot: "告别城市的快节奏，嘉宾们来到一座带菜园的小院。他们要自己劈柴、挑水、下地，也要为每期到访的客人准备一桌家常饭。没有任务、没有竞争，只有日出而作、日落而息的踏实。节目想说的很简单：生活本来就可以慢一点。",
    tags: ["慢综艺", "治愈", "田园", "温暖"],
    views: 231000,
    updatedAt: "2026-09-24",
    featured: false,
  },
  {
    id: "v08",
    title: "明星运动会",
    subtitle: "体育竞技 · 热血比拼",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=dynamic%20sports%20stadium%20with%20athletes%20and%20colorful%20flags%2C%20sports%20variety%20poster%2C%20deep%20blue%20and%20orange%20energy%2C%20no%20text&width=600&height=900&seq=17c-v08&orientation=portrait",
    heroImage: "https://readdy.ai/api/search-image?query=bright%20sports%20stadium%20with%20deep%20blue%20sky%20and%20orange%20track%20and%20crowd%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=17c-hero-v08&orientation=landscape",
    year: 2026,
    region: "中国",
    genres: ["体育", "竞技", "真人秀"],
    duration: "每周六更新",
    rating: 7.8,
    director: "综艺制作中心",
    cast: ["明星运动员", "专业教练"],
    summary: "明星嘉宾化身运动员，在专业赛场上挑战自我，为团队荣誉而战。",
    plot: "节目邀请明星嘉宾组成战队，接受短跑、游泳、射箭、拔河等项目的专业训练与正式比拼。从零基础到站上赛场，他们要克服体能极限与心理压力。输赢之外，更重要的是那份不服输的拼劲和队友之间的信任。",
    tags: ["体育", "竞技", "热血", "合家欢"],
    views: 165000,
    updatedAt: "2026-09-22",
    featured: false,
  },
];

export const TYPE_LABELS: Record<MediaType, string> = {
  movie: "电影",
  series: "电视剧",
  variety: "综艺",
};